export default {
  "meta-title": "TARISLAND",
  "meta-description": "Tarisland เป็นเกม MMORPG คลาสสิกบนพีซีและมือถือ มีทั้งบุกถล่ม, คลาสมากมาย, การเล่นข้ามอุปกรณ์ และโลกอันกว้างใหญ่รอให้ออกสำรวจ ผจญภัยมหากาพย์ไปด้วยกัน",
  "meta-keywords": "tarisland,taris,comme wow,mmo,mmorpg,multiplateforme,mmomobile,mmoPC",
  "meta-name": "เว็บไซต์อย่างเป็นทางการของ Tarisland",
  "meta-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-og-site_name": "เว็บไซต์อย่างเป็นทางการของ Tarisland",
  "meta-og-title": "เว็บไซต์อย่างเป็นทางการของ Tarisland",
  "meta-og-description": "คุณจะได้ประสบการณ์ MMORPG ที่คลาสสิกแบบข้ามแพลตฟอร์ม และรวมทีมกับเพื่อนสนิทของคุณเพื่อสนุกไปกับการบุกถล่มแบบฮาร์ดคอร์",
  "meta-og-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-og-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-og-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-twitter-site": "${HOST_NAME}",
  "meta-twitter-title": "เว็บไซต์อย่างเป็นทางการของ Tarisland",
  "meta-twitter-description": "คุณจะได้ประสบการณ์ MMORPG ที่คลาสสิกแบบข้ามแพลตฟอร์ม และรวมทีมกับเพื่อนสนิทของคุณเพื่อสนุกไปกับการบุกถล่มแบบฮาร์ดคอร์",
  "meta-twitter-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-twitter-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-twitter-image": "${HOST_NAME}/assets/images/share.jpg",


  "email_illegal": "อีเมลแอดเดรสไม่ถูกต้อง. โปรดตรวจสอบและส่งอีกครั้ง",
  "horizon_tip": "เพื่อประสบการณ์ที่ดีขึ้น โปรดหมุนอุปกรณ์ของคุณ",


  'downloadPc': "Please download on PC",


  "area": "พื้นที่",
  "select-area": "โปรดเลือกพื้นที่",
  "server": "เซิร์ฟเวอร์",
  "select-server": "โปรดเลือกเซิร์ฟเวอร์",
  "character-name": "ชื่อตัวละคร",
  "select-character": "โปรดเลือกตัวละคร",
  "please-select": "โปรดเลือก",
  "not-found-role": "ไม่พบข้อมูลตัวละคร",
  'loading': 'กำลังโหลด....',
  'pls_input_info': 'กรุณาป้อนข้อมูลล็อกอินของคุณ',
  "pls_input_email": "โปรดระบุที่อยู่อีเมล",
  'FlowHasNotBegin': 'The event has not started yet',
  'FlowHasEnd': 'The event has ended',

  // 复制到剪贴板内容 需要拼接
  "copy_clipboard-text1": "มาเป็นคู่หูของฉันใน Tarisland ตอนนี้เลย!\nคลิก/แตะที่:",
  "copy_clipboard-text2": "(ลิงก์แบบเฉพาะ)\nหากลิงก์ใช้งานไม่ได้ คุณสามารถกรอกรหัสเชิญ:",
  "friends-completed": " เพื่อนทำสำเร็จแล้วคน",
  "no-friends-completed": "ไม่มีเพื่อนทำสำเร็จ",
  "pop_invitedlist_s": "เสร็จสิ้น",
  "pop_invitedlist_f": "ยังไม่เสร็จ",
  "gift3": "แพ็กการเติบโต S1",
  "gift5": "วิญญาณหมาป่าหิมะ (ถาวร)",
  "gift6": "วิญญาณหมาป่าหิมะ (1 วัน)",
  "gift1": "บัตรของขวัญ $100",
  "gift2": "บัตรของขวัญ $50",
  "gift4": "วิญญาณเสือธาตุไฟ (ถาวร)",

  "invite_link_upper_limit": "ขออภัย ลิงก์หรือรหัสเชิญนี้มีผู้ใช้งานครบจำนวนสูงสุดที่กำหนดแล้ว",
  "invite_link_disabled": "ลิงก์เชิญไม่ถูกต้องหรือรหัสหมดอายุ กรุณาตรวจสอบกับผู้เชิญ",
  "enter_your_invitation_code": "ป้อนรหัสเชิญของคุณ",
  "act_not_start": "อีเวนต์ยังไม่เริ่ม",
  "act_finished": "อีเวนต์สิ้นสุดแล้ว",
  "download_pc": "โปรดดาวน์โหลดบนพีซี",
  "email_error": "อีเมลไม่ถูกต้อง กรุณาตรวจสอบ",
  "loadding": "กำลังโหลด…",
  "check_my_raffle_history": "ดูประวัติการจับสลากของฉัน",
  "no_raffle_history": "ไม่มีประวัติการจับสลาก",
  "system-error": "ข้อผิดพลาดของระบบ",
  "cant-invite-self": "คุณไม่สามารถเชิญตัวเอง",
}